import Text from '@deprecated-ui/common/Text';
import React from 'react';
import { SelectDateWrapper } from './styled';

interface SelectDateProps {
  label?: string;
  children?: React.ReactNode;
  className?: string;
  disabled?: boolean;
  onChange?: (val: any) => any;
  [key: string]: any
}

const SelectDate = React.memo(
  ({ label, children, className, disabled, onChange, ...props }: SelectDateProps) => (
    // @ts-expect-error
    <SelectDateWrapper className={className} disabled={disabled}>
      <Text as="label">{label}</Text>
      <select
        {...props}
        onChange={onChange}
        disabled={disabled}
        style={{ height: '28px' }}
      >
        {children}
      </select>
    </SelectDateWrapper>
  ),
);

export default SelectDate;
